import { IPublicClientApplication } from '@azure/msal-browser';
import {
  AuthProvider,
  AuthProviderCallback,
  Client,
} from '@microsoft/microsoft-graph-client';
import { loginRequest } from '../shared/authentication-config';

type File = {
  mimeType: string;
};

type Folder = {
  childCount: number;
};

export type FileTreeElement = {
  id: string;
  parentReference: {
    driveId: string;
    driveType: string;
    id: string;
    path: string;
  };
  name: string;
  webUrl: string;
  size: number;
  createdBy: {
    application?: {
      id: string;
      displayName: string;
    };
    user: {
      id?: string;
      email?: string;
      displayName: string;
    };
  };
  createdDateTime: string;
  lastModifiedBy: {
    user: {
      id?: string;
      displayName: string;
    };
  };
  lastModifiedDateTime: string;
  file?: File;
  folder?: Folder;
  modifiedSinceLastLogin?: boolean;
  '@microsoft.graph.downloadUrl'?: string;
};

export function initSharePointConnection(
  instance: IPublicClientApplication,
): Client {
  const authProvider: AuthProvider = (callback: AuthProviderCallback) => {
    instance
      .acquireTokenSilent(loginRequest)
      .then((response) => {
        callback(null, response.accessToken);
      })
      .catch((err) => {
        callback(err, null);
      });
  };
  return Client.init({ authProvider: authProvider });
}
